import { isEqualValue, isRequired } from '../../../utils/validation';

export default function validate(values) {
  const { password, repeatPassword } = values;
  const rules = {
    password:
      isRequired(password, 'Kata Sandi harus diisi'),
    repeatPassword:
      isRequired(repeatPassword, 'Konfirmasi Kata Sandi harus diisi') ||
      isEqualValue(repeatPassword, password, 'Konfirmasi Password tidak sama'),
  };

  return rules;
}
